import { render, staticRenderFns } from "./PersonalProfile.vue?vue&type=template&id=86aa427a&"
import script from "./PersonalProfile.vue?vue&type=script&lang=js&"
export * from "./PersonalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports